import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 48 48"
		{...props}
	>
		<path
			stroke="#8291AC"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M36 12 12 36m0-24 24 24"
			style={{
				stroke: '#8291ac',
				strokeOpacity: 1,
			}}
		/>
	</svg>
);
export default SvgCloseIcon;
